var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPen24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_pen24x24",
    transform: "translate(-3.001 -2.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_490_1",
    "data-name": "Component 490 \\u2013 1",
    transform: "translate(3.001 2.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46233",
    "data-name": "Path 46233",
    d: "M9.949,3.959,13.2,7.23,4.966,15.509,1.713,12.237Zm5.724-.788-1.451-1.46a1.435,1.435,0,0,0-2.035,0l-1.39,1.4L14.052,6.38,15.674,4.75a1.119,1.119,0,0,0,0-1.58ZM.01,16.835a.372.372,0,0,0,.444.444L4.081,16.4.832,13.121Z",
    transform: "translate(-.001 -1.288)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPen24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_pen24x24.18a2660cf0c183c599f87d720e811c6f.svg";